import { authClient, API } from '../index'

export const getCampaigns = () => {
  return authClient().get(`${API}/push/campaigns`)
}

export const getCampaignById = (id) => {
  return authClient().get(`${API}/push/campaigns/${id}`)
}

export const postCampaign = (data) => {
  return authClient().post(`${API}/push/campaigns`, data)
}

export const putCampaign = (id, data) => {
  return authClient().put(`${API}/push/campaigns/${id}`, data)
}

export const sendCampaign = (id) => {
  return authClient().post(`${API}/push/campaigns/${id}/send`)
}

export const cancelScheduleCampaign = (id) => {
  return authClient().post(`${API}/push/campaigns/${id}/cancel-schedule`)
}

export const deleteCampaign = (id) => {
  return authClient().delete(`${API}/push/campaigns/${id}`)
}
